var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-index-layout',{attrs:{"title":_vm.$tc('order.name', 2)}},[_c('SaleOrderCustomerIndexTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }